import config from 'config/config';

export const IS_RAMP_WIDGET_ENABLED = config.rampHostApiKey !== 'off';
